import { isRecord } from '@openx/components-core/lib/Markdown/widgets/answerWidgetPayload.ts';

export type ParsedOpenXAgentWidget<T> = { ok: true; value: T } | { ok: false; error: string };

export type Unvalidated<Key extends string> = Partial<Record<Key, unknown>>;

export const isUnvalidated = <Key extends string>(value: unknown): value is Unvalidated<Key> => isRecord(value);

export const asNonEmptyString = (value: unknown): string | null =>
  typeof value === 'string' && value.trim().length > 0 ? value.trim() : null;

export const asOneOf = <T extends string>(allowed: Record<string, T>, value: unknown): T | null =>
  Object.values(allowed).find(option => option === value) ?? null;

export const normalizeList = <T>(raw: unknown, normalize: (entry: unknown, index: number) => T | null): T[] =>
  Array.isArray(raw)
    ? raw.map((entry, index) => normalize(entry, index)).filter((entry): entry is T => entry !== null)
    : [];
